import exportFile from 'quasar/src/utils/export-file.js';

export const exportToExcel = file => {
  const contentDisposition = file.headers['content-disposition']

  const filename = contentDisposition.match(/filename="?([^"]+)"?/)[1]

  exportFile(filename, new Blob([file.data]))
}
